import { useMyPlanPrivilegeQuery } from '@/types/generated/graphql';
import { COOKIE_KEY } from '@shared/constants';
import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { planPrivilegeStore } from '@shared/store/plan-privilege.store';

export const useInitPlanPrivilege = () => {
  const authorization = Cookies.get(COOKIE_KEY.accessToken) ?? '';
  const workspaceSecret = Cookies.get(COOKIE_KEY.workspaceSecret) ?? '';

  const { data, error, loading } = useMyPlanPrivilegeQuery({
    skip: !authorization || !workspaceSecret, // skip when there is no authorization or workspace secret
  });
  const { planPrivileges, updatePlanPrivileges } = planPrivilegeStore();

  const userPlans = data?.myPlanPrivilege?.edges || [];
  const userPermissions = userPlans?.map(
    (perms) => `${perms?.screen?.slug}.${perms?.module?.slug}.${perms?.privilege?.slug}`
  );

  // using object for quick search operation - O(1)
  const permissionsObj: Record<string, boolean> = {};
  for (const userPermission of userPermissions) {
    permissionsObj[userPermission] = true;
  }

  useEffect(
    function updatePlanPrivilegesInStore() {
      if (userPermissions && !error && !loading) {
        updatePlanPrivileges(permissionsObj);
      } else if (!loading || error) updatePlanPrivileges({});
    },
    [loading, error, data]
  );

  return { fetchingPlanPrivileges: loading || !planPrivileges };
};
